import { EDescriptionTextItemType } from '@shared/common/data/products';

export const descriptionData = [
  {
    imgSrc: 'assets/images/TM-BK2-index01.jpg',
    text: [
      {
        type: EDescriptionTextItemType.caption,
        text: /* html */ `<span style="font-family: ZenMaruGothic">電車好きなあの子へ電車の絵本を</span>`,
      },
      {
        type: EDescriptionTextItemType.regular,
        text: `電車好きな子にピッタリなプレゼント。大好きな電車の運転士になったり、日本初の地下鉄道を作ったり。<br>さぁ、あなたの子どもはどんな大冒険を始めますか？`,
      },
    ],
  },
  {
    imgSrc: 'assets/images/TM-BK2-index02.jpg',
    text: [
      {
        type: EDescriptionTextItemType.caption,
        text: /* html */ `<span style="font-family: ZenMaruGothic">その子だけの特別な一冊に</span>`,
      },
      {
        type: EDescriptionTextItemType.regular,

        text: `大好きなあの子の写真を入れて、特別な想いをつづったら……世界に一冊だけの電車の絵本の出来上がり！<br>大好きなものを追うあの子の背中を押すのような特別な言葉を綴って、大人になっても特別な絵本としましょう！`,
      },
    ],
  },
];
